import { Device, DeviceAttributes, DeviceType } from 'dashboard/models/device';
import { ApiModel } from 'lib/interfaces/api';

export function createPreviewDevice(attributes?: Partial<DeviceAttributes>, id?: string): Device {
  return {
    attributes: {
      'os-name': 'Mac',
      'os-full-version': '10.10.2',
      'device-type': DeviceType.Desktop,
      'browser-name': 'Chrome',
      'browser-full-version': '95.0.4638.69',
      'browser-fingerprint': '46a09c2889b811eb9fdcb7efe3c462a3',
      ...attributes,
    },
    id: id || 'dev_123',
    type: ApiModel.Device,
  };
}
